export const getAnnouncementsLastSeenKey = ({ userId, userGuid }: { userId?: number; userGuid: string }) =>
    `last-seen-go-announcements-${userId || userGuid}`;
